import table from "../../General CSS/Table.module.css";

import React, {useEffect, useState} from "react";
import {WiFiInterface} from "../../Types/Wifi";
import {getWifi} from "../../API/WiFiManager";
import Header from "../../Header";

export default function Wifi() {
    return (
        <div className="content">
            <Header returnLink={"/"} page={"Wifi"}/>
            <DisplayWifiDetails />
        </div>
    )
}

function DisplayWifiDetails(): React.ReactElement {
    const [content, setContent] = useState<React.ReactNode>("Loading...");

    useEffect(() => {
        const fetchContent = async () => {
            const element = await LoadWifiDetails();
            setContent(element);
        }

        fetchContent();
    }, []);

    return (<>{content}</>);
}

async function LoadWifiDetails(): Promise<React.ReactElement> {
    try {
        const networks: WiFiInterface[] = await getWifi();

        return (
            <div className={table.table}>
                <table>
                    <thead>
                    <tr>
                        <th>SSID</th>
                        <th>Password</th>
                    </tr>
                    </thead>
                    <tbody>
                    {networks.map((net, index) => (
                        <tr key={index}>
                            <td>{net.SSID}</td>
                            <td>{net.PSK}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    } catch (error) {
        return <>Couldn't communicate with API</>;
    }
}